import type { TableInformation } from '../../../config/flavourConfig';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import type {
    PrhHolidayHomeDTO,
    PrhHouseDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/prh';
import { COVERABLE_CODE } from '../../../constants/coverable';

export const getClaimsHistoryCoverableDetailsConfig = (
    coverable: CoverableDTO,
    getHippoText: (resourceKey: string, replaceTexts?: Record<string, string> | undefined) => string
): TableInformation | undefined => {
    switch (coverable.flavourCode) {
        case COVERABLE_CODE.prhHouse:
            return getPrhHouseClaimsHistoryConfig(coverable as PrhHouseDTO, getHippoText);
        case COVERABLE_CODE.prhHolidayHome:
            return getPrhHolidayHomeClaimsHistoryConfig(
                coverable as PrhHolidayHomeDTO,
                getHippoText
            );
        default:
            return undefined;
    }
};

const getPrhHouseClaimsHistoryConfig = (
    coverable: PrhHouseDTO,
    getHippoText: (resourceKey: string, replaceTexts?: Record<string, string> | undefined) => string
): TableInformation => {
    return {
        title: getHippoText('DSS-COVERABLE-DETAILS-CLAIMS-HISTORY-TITLE', {
            coverable: coverable.name ?? ''
        }),
        rowsInformation: [
            {
                name: getHippoText('DSS-COVERABLE-DETAILS-CLAIMS-HISTORY-CLOUDBURST'),
                fieldValue: coverable.cloudburstClaimsInPast5Years
            },
            {
                name: getHippoText('DSS-COVERABLE-DETAILS-CLAIMS-HISTORY-OTHER'),
                fieldValue: coverable.otherClaimsInPast3Years
            }
        ]
    };
};

const getPrhHolidayHomeClaimsHistoryConfig = (
    coverable: PrhHolidayHomeDTO,
    getHippoText: (resourceKey: string, replaceTexts?: Record<string, string> | undefined) => string
): TableInformation => {
    return {
        title: getHippoText('DSS-COVERABLE-DETAILS-CLAIMS-HISTORY-TITLE', {
            coverable: coverable.name ?? ''
        }),
        rowsInformation: [
            {
                name: getHippoText('DSS-COVERABLE-DETAILS-CLAIMS-HISTORY-CLOUDBURST'),
                fieldValue: coverable.cloudburstClaimsInPast5Years
            },
            {
                name: getHippoText('DSS-COVERABLE-DETAILS-CLAIMS-HISTORY-OTHER'),
                fieldValue: coverable.otherClaimsInPast3Years
            }
        ]
    };
};
